require('fancybox')($);

$(function(){
	$('.fancybox').fancybox({
		padding: 0,
		autoScale: true,
		maxWidth: 1280,
		maxHeight: 1280,
		aspectRatio: true,
		padding: ($(window).width() < 768) ? 20 : 80,

		tpl: {
			closeBtn : '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"><div class="cssicon close"></div></a>',
			next     : '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><div class="cssicon arrow arrow-right"></div></a>',
			prev     : '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><div class="cssicon arrow arrow-left"></div></a>'
		}
	});
});


/** WEBPACK FOOTER **
 ** ./Frontend/js/vendor/fancybox-init.js
 **/